import type { NodeReducer } from './';

const rule: NodeReducer = () => {
	return '';
};

export default rule;
